import mixpanel from "mixpanel-browser";
import { AnalyticsEventBus, event } from "../analytics";

export class BannerMixpanelHandlers {
  static handleAll() {
    this.handleViewEvents();
  }

  static handleViewEvents() {
    AnalyticsEventBus.$on(event.banner.hide_banner_section, (data) => {
      mixpanel.track(event.banner.hide_banner_section);
    });
    AnalyticsEventBus.$on(event.banner.show_banner_section, (data) => {
      mixpanel.track(event.banner.show_banner_section);
    });
    AnalyticsEventBus.$on(event.banner.show_banner_detail, (data) => {
      mixpanel.track(event.banner.show_banner_detail, { ...data });
    });
    AnalyticsEventBus.$on(event.banner.click_cta_button, (data) => {
      mixpanel.track(event.banner.click_cta_button, { ...data });
    });
    AnalyticsEventBus.$on(event.banner.click_tag_feature_discovery, (data) => {
      mixpanel.track(event.banner.click_tag_feature_discovery, { ...data });
    });
    AnalyticsEventBus.$on(event.banner.click_feature_discovery_card, (data) => {
      mixpanel.track(event.banner.click_feature_discovery_card, { ...data });
    });
  }
}
